import { jsx } from "react/jsx-runtime";
import { DecoratorNode } from "lexical";
import { PlayerComponent } from "../../plugins/index.js";
import { $createVideoNode } from "./VideoNode.helpers.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function VideoNode_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else VideoNode_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
class VideoNode extends DecoratorNode {
    static getType() {
        return 'video';
    }
    static clone(node) {
        return new VideoNode(node.src, node.description, node.__key);
    }
    createDOM() {
        return document.createElement('span');
    }
    decorate(editor) {
        return /*#__PURE__*/ jsx(PlayerComponent, {
            src: this.src,
            description: this.description,
            editable: editor._editable
        });
    }
    exportJSON() {
        return _object_spread_props(_object_spread({}, super.exportJSON()), {
            type: 'video',
            version: 1,
            src: this.src,
            description: this.description
        });
    }
    static importJSON(serializedNode) {
        return $createVideoNode(serializedNode.src, serializedNode.description).updateFromJSON(serializedNode);
    }
    getTextContent() {
        return this.description || '';
    }
    constructor(src, description, key){
        super(key);
        this.src = src;
        this.description = description;
    }
}
export { VideoNode };
